<template>
  <div
    v-outside-click="closeDropdown"
    class="items"
    :style="{ ...style, minWidth: style.minWidth ? style.minWidth : '100%' }"
  >
    <div
      v-for="(option, i) of options"
      :key="i"
      class="items__item"
      style="pointer-events: auto"
      :class="{ active: index == i }"
      @click="selectItem(option)"
    >
      {{ option }}
    </div>
  </div>
</template>

<script>
import hotkeys from "hotkeys-js";
import { HotkeyScopes } from "../../utils/constants";

export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    style: {
      required: false,
      default: {},
    },
  },
  data() {
    return {
      selected: this.default || this.options[0] || null,
      prevScope: null,
      index: 0,
    };
  },
  mounted() {
    this.prevScope = hotkeys.getScope();
    this.$store.dispatch("setScope", HotkeyScopes.SelectOption);
    hotkeys("escape", HotkeyScopes.SelectOption, (event) => {
      event.preventDefault();
      this.closeDropdown();
    });
    hotkeys("up", HotkeyScopes.SelectOption, this.moveUp);
    hotkeys("down", HotkeyScopes.SelectOption, this.moveDown);
    hotkeys("space", HotkeyScopes.SelectOption, this.handleSelectKey);
    hotkeys("enter", HotkeyScopes.SelectOption, this.handleSelectKey);
  },
  beforeUnmount() {
    this.$store.dispatch("setScope", this.prevScope);
    hotkeys.unbind("up,down,space,enter,escape", HotkeyScopes.SelectOption);
  },
  methods: {
    handleSelectKey(event) {
      event.preventDefault();
      this.selectItem(this.options[this.index]);
      this.closeDropdown();
    },
    closeDropdown() {
      this.$emit("close");
    },

    handleSensitive(event) {
      event.preventDefault();
      this.isSensitive = !this.isSensitive;
    },
    moveDown(event) {
      event.preventDefault();
      this.index = (this.index + 1) % this.options.length;
    },
    moveUp(event) {
      event.preventDefault();
      this.index = this.index <= 0 ? this.options.length - 1 : (this.index - 1) % this.options.length;
    },
    selectItem(option) {
      this.$emit("input", option);
      this.closeDropdown();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables.less";

.selected {
  cursor: pointer;
  user-select: none;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.items {
  position: absolute;
  left: 0;
  right: 0;
  top: 33px;
  z-index: 1;
  color: @kk-color-primary-blue;
  overflow: hidden;
  border-radius: 4px;
  background-color: #fdfeff;
  box-shadow: rgba(8, 50, 119, 0.25) -2px 2px 8px;
  width: max-content;
  padding: 4px;
  border: 1px solid #eaedf1;

  &__item {
    padding: 5px 10px;
    margin-bottom: 2px;
    cursor: pointer;
    border-radius: 3px;

    &:hover {
      background-color: @kk-sky-blue;
    }
    &.active {
      background-color: @kk-color-primary-blue;
      color: @kk-color-light-white;
    }
  }
}
</style>
